export default {
  en: {
    /** 登録追加 */
    RegisterAdditionalModal: {
      title: 'Register additional information'
    }
  },
  'zh-hant': {
    /** 登録追加 */
    RegisterAdditionalModal: {
      title: '登入資訊'
    }
  },
  ja: {
    /** 登録追加 */
    RegisterAdditionalModal: {
      title: '追加情報を登録する'
    }
  },
  es: {
    /** 登録追加 */
    RegisterAdditionalModal: {
      title: 'Registrar información adicional'
    }
  },
  'pt-br': {
    /** 登録追加 */
    RegisterAdditionalModal: {
      title: 'Registrar informações adicionais'
    }
  }
}
